export default __webpack_public_path__ + "images/stripe-payment-element/diners-club-international-761cb5edb4ac12c6180a74ca6c6d5263.svg";